import { FeaturedContentTypes as Type } from '../../../types/featuredcontent';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const UpdateFeaturedContentReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case Type.UPDATE_FEATURED_CONTENT_REQUEST:
      return { ...state, loading: true, error: null, data: null };
    case Type.UPDATE_FEATURED_CONTENT_REQUEST_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case Type.UPDATE_FEATURED_CONTENT_REQUEST_FAILURE:
      return { ...state, error: action.error, loading: false, data: null };
    case Type.RESET_UPDATE_FEATURED_CONTENT_REQUEST:
      return { ...initialState };
    default:
      return state;
  }
};

export default UpdateFeaturedContentReducer;
